function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Avatar, Box, Flex, Stack, Text } from '@chakra-ui/react';
import DocumentScan from '../icons/lord/DocumentScan';
import { LordIconSizes } from '@/types/client';
import { FormattedMessage, useIntl } from 'react-intl';
import useIntlMemo from '@/hooks/useIntlMemo';
import TextTransition from './TextTransition';
function BadWordHighlight(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({
        as: "span",
        color: "orange.400",
        transition: "color 0.5s",
        transitionDelay: "1s"
    }, props), {
        children: children
    }));
}
export default function ChatFilterPanel(props) {
    var intl = useIntl();
    var ref = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), ready = _React_useState[0], setReady = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState('loop-scan'), 2), iconState = _React_useState1[0], setIconState = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState('morph-scan-OK'), 2), pendingIconState = _React_useState2[0], setPendingIconState = _React_useState2[1];
    var iconColor = React.useMemo(function() {
        if (iconState === 'morph-scan-OK') {
            return 'green.400';
        }
        if (iconState === 'morph-scan-WRONG') {
            return 'red.400';
        }
        return 'textPrimary';
    }, [
        iconState
    ]);
    var message = useIntlMemo(function() {
        if (pendingIconState === 'morph-scan-OK') {
            return intl.formatMessage({
                id: "ErhTr6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Hi! how are you?"
                    }
                ]
            });
        }
        if (pendingIconState === 'morph-scan-WRONG') {
            return intl.formatMessage({
                id: "zggXhP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "You are a "
                    },
                    {
                        children: [
                            {
                                type: 0,
                                value: "butthead"
                            }
                        ],
                        type: 8,
                        value: "badWord"
                    },
                    {
                        type: 0,
                        value: "!"
                    }
                ]
            }, {
                badWord: function(word) {
                    return /*#__PURE__*/ _jsx(BadWordHighlight, {
                        color: iconColor,
                        children: word
                    });
                }
            });
        }
        return null;
    }, [
        pendingIconState,
        iconColor
    ]);
    React.useEffect(function() {
        var currentRef = ref.current;
        if ((currentRef === null || currentRef === void 0 ? void 0 : currentRef.playFromBeginning) == null || !ready) {
            return;
        }
        currentRef.playFromBeginning();
    }, [
        ref,
        ready
    ]);
    function handleComplete() {
        if (ref.current == null || !ready) {
            return;
        }
        if (iconState === 'loop-scan') {
            var _ref_current;
            setIconState(pendingIconState);
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.playFromBeginning();
            return;
        }
        setTimeout(function() {
            var _ref_current;
            setIconState('loop-scan');
            setPendingIconState(iconState === 'morph-scan-OK' ? 'morph-scan-WRONG' : 'morph-scan-OK');
            (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.playFromBeginning();
        }, 1000);
    }
    return /*#__PURE__*/ _jsxs(Flex, _object_spread_props(_object_spread({
        boxShadow: "base",
        zIndex: 2,
        borderWidth: 1,
        borderColor: "borderSecondary",
        borderRadius: "xl",
        paddingX: 4,
        paddingY: 4,
        alignItems: "center",
        gap: 4
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Avatar, {
                size: "sm",
                bgColor: pendingIconState === 'morph-scan-OK' ? 'green.400' : 'red.400',
                transition: "background-color 0.5s"
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 1,
                lineHeight: 1,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        zIndex: 2,
                        fontSize: "sm",
                        fontWeight: "bold",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "mbjE1N",
                            defaultMessage: "Chatter:"
                        })
                    }),
                    /*#__PURE__*/ _jsx(TextTransition, {
                        children: message
                    }, pendingIconState)
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                marginLeft: "auto",
                color: iconColor,
                transition: "color 0.5s",
                transitionDelay: iconState !== 'loop-scan' ? '1s' : '0s',
                children: /*#__PURE__*/ _jsx(DocumentScan, {
                    size: LordIconSizes.MEDIUM,
                    state: iconState,
                    ref: ref,
                    onComplete: handleComplete,
                    onReady: function() {
                        return setReady(true);
                    }
                })
            })
        ]
    }));
}
